import { render } from "./PostTranscriptModal.vue?vue&type=template&id=915d0c62&ts=true"
import script from "./PostTranscriptModal.vue?vue&type=script&lang=ts"
export * from "./PostTranscriptModal.vue?vue&type=script&lang=ts"

import "./PostTranscriptModal.vue?vue&type=style&index=0&id=915d0c62&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__